module.exports = __webpack_public_path__ + "img/icon-cart.37806cd2.svg";